import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"clock\">\n    <path fill-rule=\"nonzero\" d=\"M6.25 12.5a6.25 6.25 0 1 1 0-12.5 6.25 6.25 0 0 1 0 12.5zm0-1.5a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5zm.5-4.737l2.147.965-.406.913L5.75 7.007v-4h1v3.256z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol